module.exports = __webpack_public_path__ + "img/icon-btn-del.ece7201c.png";